import React, { useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import styles from './can.module.css';

const IconTextComponent = ({ text, icon, colors }) => {
  const handleComplete = () => {
    setTimeout(() => {
      playerRef1?.current?.playFromBeginning();
    }, 2500);
  };

  const playerRef1 = useRef(null);

  useEffect(() => {
    playerRef1?.current?.playFromBeginning();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.icon}>
          <Player
            icon={icon}
            ref={playerRef1}
            size="100%"
            colorValues={colors || "primary:#C4727E,secondary:#C4727E"}
            onComplete={handleComplete}
          />
        </div>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  );
};

export default IconTextComponent;